
const digest = '67c4e8ce10aa11a637ed00197bf3859a6fc72fdc1e3a457fe1f01039dd9d4cee';
const classes = {"wrapper":"_wrapper_11vid_1"};
const css = `._wrapper_11vid_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  